import React, { useState } from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import api from '../services/api';

export default function Contact({ isDark }) {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState('idle');

  const contacts = [
    {
      icon: Phone,
      title: 'Телефон',
      info: '+38 (067) 492-04-73',
      color: 'from-blue-500 to-cyan-500',
    },
    {
      icon: Mail,
      title: 'Email',
      info: 'shlihtaaneka@gmail.com',
      color: 'from-green-500 to-emerald-500',
    },
    {
      icon: MapPin,
      title: 'Адреса',
      info: 'вул. Соборна, Вінниця',
      color: 'from-purple-500 to-pink-500',
    },
  ];

  return (
    <section
      id='contact'
      className={`py-20 px-4 ${isDark ? 'bg-gray-800' : 'bg-white'}`}
    >
      <div className='max-w-6xl mx-auto'>
        <div className='text-center mb-16'>
          <h2
            className={`text-4xl font-bold mb-6 ${
              isDark
                ? 'text-white'
                : 'bg-gradient-to-r from-orange-600 to-rose-600 bg-clip-text text-transparent'
            }`}
          >
            Зв'яжіться з нами 📞
          </h2>
          <p
            className={`text-xl ${isDark ? 'text-gray-300' : 'text-gray-600'}`}
          >
            Маєте питання? Ми завжди раді допомогти!
          </p>
        </div>

        <div
          className={`${
            isDark
              ? 'bg-gray-800 border-gray-700'
              : 'bg-white border-orange-200'
          } border rounded-2xl p-6 mb-12 max-w-2xl mx-auto`}
        >
          <form
            onSubmit={async (e) => {
              e.preventDefault();
              setStatus('loading');
              try {
                await api.submitContactForm(form);
                setStatus('success');
                setForm({ name: '', email: '', message: '' });
              } catch (err) {
                setStatus('error');
              }
            }}
            className='space-y-4'
          >
            <div className='grid md:grid-cols-2 gap-4'>
              <input
                required
                type='text'
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                placeholder="Ваше ім'я"
                className={`${
                  isDark
                    ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400'
                    : 'bg-white border-orange-200 text-gray-900 placeholder-gray-500'
                } w-full px-4 py-3 rounded-xl border`}
              />
              <input
                required
                type='email'
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                placeholder='Email'
                className={`${
                  isDark
                    ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400'
                    : 'bg-white border-orange-200 text-gray-900 placeholder-gray-500'
                } w-full px-4 py-3 rounded-xl border`}
              />
            </div>
            <textarea
              required
              rows={5}
              value={form.message}
              onChange={(e) => setForm({ ...form, message: e.target.value })}
              placeholder='Повідомлення'
              className={`${
                isDark
                  ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400'
                  : 'bg-white border-orange-200 text-gray-900 placeholder-gray-500'
              } w-full px-4 py-3 rounded-xl border`}
            />
            <button
              disabled={status === 'loading'}
              className={`btn-primary w-full ${
                isDark ? '!from-orange-600 !to-orange-500' : ''
              } ${status === 'loading' ? 'opacity-70 cursor-not-allowed' : ''}`}
            >
              {status === 'loading' ? 'Надсилання...' : 'Надіслати'}
            </button>
            {status === 'success' && (
              <p className='text-green-500 text-center'>
                Дякуємо! Ми зв'яжемося з вами.
              </p>
            )}
            {status === 'error' && (
              <p className='text-red-500 text-center'>
                Сталася помилка. Спробуйте ще раз.
              </p>
            )}
          </form>
        </div>

        <div className='grid md:grid-cols-3 gap-8 mb-12'>
          {contacts.map((contact, index) => {
            const Icon = contact.icon;
            return (
              <div key={index} className='text-center'>
                <div
                  className={`${
                    isDark ? 'bg-gray-700' : 'bg-white'
                  } backdrop-blur-sm border ${
                    isDark ? 'border-gray-600' : 'border-orange-200'
                  } rounded-2xl p-8 hover:shadow-lg transition-all duration-300 hover:scale-105`}
                >
                  <div
                    className={`w-16 h-16 bg-gradient-to-r ${contact.color} rounded-2xl flex items-center justify-center mx-auto mb-6 hover:scale-110 transition-transform`}
                  >
                    <Icon className='w-8 h-8 text-white' />
                  </div>
                  <h3
                    className={`font-bold text-lg mb-3 ${
                      isDark ? 'text-white' : 'text-gray-800'
                    }`}
                  >
                    {contact.title}
                  </h3>
                  <p
                    className={`${isDark ? 'text-gray-300' : 'text-gray-600'}`}
                  >
                    {contact.info}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        <div className='text-center'>
          <h3
            className={`text-2xl font-bold mb-8 ${
              isDark ? 'text-white' : 'text-gray-800'
            }`}
          >
            Слідкуйте за нами 📱
          </h3>
          <div className='flex justify-center gap-6'>
            <button className='p-4 bg-gradient-to-r from-pink-500 to-red-500 text-white rounded-2xl hover:scale-110 transition-all duration-300 shadow-lg'>
              <span className='text-2xl'>📷</span>
            </button>
            <button className='p-4 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-2xl hover:scale-110 transition-all duration-300 shadow-lg'>
              <span className='text-2xl'>📘</span>
            </button>
            <button className='p-4 bg-gradient-to-r from-green-500 to-emerald-500 text-white rounded-2xl hover:scale-110 transition-all duration-300 shadow-lg'>
              <span className='text-2xl'>💬</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
